"use strict";

String.prototype.endsWith = function (suffix) {
    suffix = suffix ? suffix.toLowerCase() : "";
    return this.toLowerCase().indexOf(suffix, this.length - suffix.length) !== -1;
};

angular
    .module("BannerFlowApp")
    .controller(
        "FeedController",
        function FeedController(
            $scope,
            $http,
            $rootScope,
            $timeout,
            $stateParams,
            $q,
            AuthInfo,
            ngDialog,
            Page,
            Feed,
            History,
            Notification,
            Utils
        ) {
            if (!AuthInfo.HasFeatures([$rootScope.FEATURE_FEEDS])) {
                Utils.GoHome();
                return;
            }

            $rootScope.hideHeader = false;

            $scope.model = {
                showRequestFeature: false,
                tempFeedSourceUrl: "",
                selectedPreviewCampaign: null,
                selectedPreviewBanner: null
            };

            $scope.editingFeedSource = false;
            $scope.selectedField = null;
            $scope.selectedOperation = null;
            $scope.operationsAdvancedMode = false;
            $scope.feedPreviewCanceler = null;
            $rootScope.feedIsDirty = false;
            $scope.feedLoading = true;
            $scope.isSaving = false;
            $scope.feedName = "My new feed";
            $scope.disableSaveFeed = false;
            $scope.feedPreviewLoading = false;
            $scope.addFieldMode = false;
            $scope.navTab = 0;
            $scope.feedFieldBrowserCallback = null;
            $scope.feedFieldPickerStartNode = null;
            $scope.errorText = "";
            $scope.delayedText = "";
            $scope.isDirty = false;

            $scope.$watch("navTab", function (n, o) {
                if (n === o) return;

                $scope.selectedOperation = null;
                $scope.selectedField = null;
            });

            $scope.operations = new Array(
                {
                    type: "0",
                    name: "Sort",
                    description:
                        "If your items are arranged in the wrong order, add a custom sorting. Any field can be sorted in any order.",
                    template: {
                        type: "0",
                        name: "Sort",
                        relativePath: "",
                        groupPath: ""
                    }
                },
                {
                    type: "2",
                    name: "Priority",
                    description:
                        "Sometimes certain items are to be prioritized higher than others. If so, add a custom priority, based on any field in your content.",
                    template: {
                        type: "2",
                        name: "Priority",
                        invariantCase: true,
                        relativePath: "",
                        groupPath: "",
                        subType: "0",
                        matches: [
                            {
                                search: "",
                                replace: "",
                                disabled: false
                            }
                        ]
                    }
                },
                {
                    type: "3",
                    name: "Filter",
                    description:
                        "It's easy to add a custom filter to your dynamic content. Only want to display products with a price lower or equal to $50? No problems!",
                    template: {
                        type: "3",
                        name: "Filter",
                        relativePath: "",
                        invariantCase: true,
                        groupPath: "",
                        subType: "0",
                        matches: [
                            {
                                search: "",
                                replace: "",
                                disabled: false
                            }
                        ]
                    }
                },
                {
                    type: "5",
                    name: "Replace text",
                    description:
                        "Replacing texts can sometimes be useful. Add a replace filter and specify what text on which field that should be replaced, and the text to replace it.",
                    template: {
                        type: "5",
                        name: "Replace text",
                        invariantCase: true,
                        relativePath: "",
                        groupPath: "",
                        matches: [
                            {
                                search: "",
                                replace: "",
                                disabled: false
                            }
                        ]
                    }
                }
            );

            $scope.loadFeed = function (feed) {
                if (!feed) {
                    return;
                }

                if (feed.folder) {
                    Page.SetPrevious("Feeds", "root.feeds.folder", { folderId: feed.folder }, false);
                }

                if (feed.isLocked) {
                    $scope.isLocked = true;
                    $scope.loading = false;
                    $scope.feedLoading = false;
                    $scope.feedData = feed;

                    return;
                }

                $scope.delayedText = "";

                //Ugly shit to get dropdown to match values...
                if (feed.interval) {
                    feed.interval = feed.interval.toString();
                }

                $scope.feedLoading = true;

                //Remove old watchers
                if ($scope.watcher1) $scope.watcher1();
                if ($scope.watcher2) $scope.watcher2();
                if ($scope.watcher3) $scope.watcher3();
                if ($scope.watcher4) $scope.watcher4();
                if ($scope.watcher5) $scope.watcher5();

                $scope.model.tempFeedSourceUrl = feed.feedData;

                for (var i = 0; i < feed.operations.length; i++) {
                    feed.operations[i].type = "" + feed.operations[i].type;
                    feed.operations[i].subType = "" + feed.operations[i].subType;

                    if (feed.operations[i].type === "0" || feed.operations[i].type === "1") {
                        if (!feed.operations[i].subTypeData) {
                            feed.operations[i].subTypeData = {
                                fromTimezone: "0",
                                toTimeZone: "0",
                                outputFormat: "yyyy-MM-dd",
                                outputCulture: null,
                                inputFormat: null
                            };
                        } else {
                            try {
                                feed.operations[i].subTypeData = JSON.parse(
                                    feed.operations[i].subTypeData
                                );
                            } catch (e) {
                                feed.operations[i].subTypeData = {};
                            }
                        }
                    }
                }

                if (feed.folders != null) {
                    $scope.model.breadcrumbs = feed.folders.map(function (folder) {
                        return {
                            id: folder.id,
                            name: folder.name,
                            route: "root.feeds.folder({ folderId: '{0}' })".format(folder.id)
                        };
                    });
                }

                $scope.feedData = feed;

                History.AddVisitedObject(feed.id, feed.name, null, "feed");

                $scope.feedData.interval =
                    $scope.feedData.interval === null ? "788400000" : $scope.feedData.interval;

                $scope.feedData.operations.sort(function (a, b) {
                    return a.position > b.position;
                });

                $scope.feedData.properties.sort(function (a, b) {
                    return a.position > b.position;
                });

                $scope.watcher1 = $scope.$watch(
                    "feedData",
                    function (n, o) {
                        if ($scope.isSaving) {
                            $rootScope.feedIsDirty = false;
                            $scope.isSaving = false;
                            return;
                        }

                        if (n != o && o != null) {
                            $rootScope.feedIsDirty = true;
                        }
                    },
                    true
                );

                $scope.watcher2 = $scope.$watch(
                    "feedData.feedData",
                    function (n, o) {
                        if (n === o) return;
                        $scope.isDirty = true;
                    },
                    true
                );

                $scope.watcher3 = $scope.$watch(
                    "feedData.operations",
                    function (n, o) {
                        $scope.isDirty = true;
                    },
                    true
                );

                $scope.watcher4 = $scope.$watch(
                    "feedData.properties",
                    function (n, o) {
                        if (n === o) {
                            return;
                        }

                        $scope.isDirty = true;

                        if (n.length === o.length) {
                            var changed = null;
                            for (var i = 0; i < n.length; i++) {
                                if (n[i].name != o[i].name) {
                                    changed = n[i];
                                    break;
                                }
                            }

                            if (changed) {
                                changed.name = $scope.generateUniqeName(changed.name, changed);
                            }
                        }
                    },
                    true
                );

                $scope.watcher5 = $scope.$watch("feedData.feedsToUse", function (n, o) {
                    if (n === o) return;

                    const defaultFeedsToUse = 300;
                    const maxFeedsToUse = 1000;

                    if (isNaN(n)) $scope.feedData.feedsToUse = defaultFeedsToUse;
                    else if (parseInt(n) > maxFeedsToUse) {
                        $scope.feedData.feedsToUse = maxFeedsToUse;
                    }
                });

                if (feed.isDelayed) {
                    $scope.delayedText =
                        "This feed source had a considerable amount of failed regenerations in a row, " +
                        "therefore its next regeneration is delayed until " +
                        new Date(feed.regenerate).toLocaleString() +
                        " local time.";
                }

                $scope.fillFeedTree(function () {
                    $timeout(function () {
                        $scope.feedLoading = false;
                    }, 250);
                });
            };

            Feed.get(
                {
                    id: $stateParams.feedId
                },
                function (feed) {
                    $scope.loadFeed(feed);
                },
                function (_, status) {
                    $scope.model.feedNotFound = status === 404;
                }
            );

            $scope.editFeedSource = function () {
                $scope.editingFeedSource = true;
                $timeout(function () {
                    $("#feed-source-input").select();
                }, 100);
            };

            $scope.cancelEditFeedSource = function () {
                $scope.editingFeedSource = false;
                $scope.model.tempFeedSourceUrl = $scope.feedData.feedData;
            };

            $scope.updateFeedSourceUrl = function () {
                $scope.feedLoading = true;

                // write the input value to the resolved url prop
                $scope.feedData.feedData = $scope.model.tempFeedSourceUrl;

                // write the input value to the url metadata
                if ($scope.feedData.source) {
                    $scope.feedData.source.metadata[0].data.value = $scope.model.tempFeedSourceUrl;
                }

                $scope.editingFeedSource = false;
                $scope.feed = new Array();

                $scope.fillFeedTree(function () {
                    $timeout(function () {
                        $scope.feedLoading = false;
                    }, 250);
                });
            };

            $scope.generateUniqeName = function (newName, currText) {
                var cleanName = newName.replace(/\d+$/, "");

                var find = _.find($scope.feedData.properties, function (p) {
                    if (currText != null && currText === p) return false;
                    return p.name === newName;
                });

                if (!find) {
                    return newName;
                } else {
                    find = true;
                    var index = 0;

                    while (find) {
                        index++;
                        find = _.find($scope.feedData.properties, function (p) {
                            if (currText != null && currText === p) return false;
                            return p.name === cleanName + "" + index;
                        });
                    }
                    return cleanName + index;
                }
            };

            $scope.fillFeedTree = function (callback) {
                var data = {
                    id: $scope.feedData.id,
                    feedData: $scope.feedData.feedData,
                    flattenFeed: $scope.feedData.flattenFeed,
                    flattenPath: $scope.feedData.flattenPath,
                    source: $scope.feedData.source
                };

                Feed.leafs(data, function (response) {
                    if (response.data.error) {
                        $scope.feedLoading = false;
                    } else {
                        $scope.feedLeafs = response.data;
                        $scope.feedFieldPickerStartNode = $scope.feedLeafs;
                        if (callback) callback();
                    }

                    $scope.loadPreview();
                });
            };

            $scope.cleanUpFeedRequest = function (data) {
                let feedsToUse = data.feedsToUse;
                if (feedsToUse === undefined || feedsToUse === null || feedsToUse === "")
                    feedsToUse = 50;

                data.feedsToUse = parseInt(feedsToUse);
                data.interval = parseInt(data.interval);

                for (var i = 0; i < data.operations.length; i++) {
                    if (data.operations[i].position && data.operations[i].position != null) {
                        data.operations[i].position = parseInt(data.operations[i].position);
                    }

                    if (data.operations[i].type && data.operations[i].type != null) {
                        data.operations[i].type = parseInt(data.operations[i].type);
                    }

                    if (data.operations[i].subType && data.operations[i].subType != null) {
                        data.operations[i].subType = parseInt(data.operations[i].subType);
                    }

                    if (data.operations[i].matches) {
                        for (var j = data.operations[i].matches.length - 1; j >= 0; j--) {
                            if (data.operations[i].matches[j].order != null) {
                                data.operations[i].matches[j].order = parseInt(
                                    data.operations[i].matches[j].order
                                );
                            }

                            if (
                                (!data.operations[i].matches[j].search &&
                                    !data.operations[i].matches[j].replace) ||
                                (data.operations[i].matches[j].search === "" &&
                                    data.operations[i].matches[j].replace === "")
                            ) {
                                data.operations[i].matches.splice(j, 1);
                            }
                        }
                    }

                    if (data.operations[i].type === 0 || data.operations[i].type === 1) {
                        if (!data.operations[i].subTypeData) data.operations[i].subTypeData = {};

                        data.operations[i].subTypeData.outputFormat =
                            data.operations[i].subTypeData.outputFormat || "yyyy-MM-dd";
                        data.operations[i].subTypeData = JSON.stringify(data.operations[i].subTypeData);
                    }
                }

                return data;
            };

            $scope.cancelLoadPreview = function () {
                if ($scope.feedPreviewCanceler) $scope.feedPreviewCanceler.resolve();
            };

            $scope.loadPreview = function (callback) {
                $scope.isDirty = false;
                $scope.errorText = "";
                $scope.feedPreviewLoading = true;

                var data = angular.copy($scope.feedData);
                data = $scope.cleanUpFeedRequest(data);
                data.id = $scope.feedData.id;

                $scope.feedPreviewCanceler = $q.defer();

                if ($scope.feedData.feedData) {
                    $http({
                        method: "POST",
                        url: "{0}/api/brands/{1}/feeds/preview".format(
                            BANNERFLOW_LEGACY_URL,
                            AuthInfo.LoggedInUser.currentBrand.id
                        ),
                        data: data,
                        timeout: $scope.feedPreviewCanceler.promise
                    })
                        .success(function (data) {
                            $scope.model.fullPreviewData = data;

                            $scope.feedPreviewCanceler = null;
                            if (!data) {
                                $scope.isDirty = true;
                                $scope.feedPreviewLoading = false;
                                return;
                            }

                            if (data.feeds.length === 0) {
                                $scope.errorText = "No items";
                                $scope.feed = null;
                                $scope.feedPreviewLoading = false;
                                return;
                            }
                            if (data.feeds[0].error) {
                                $scope.errorText = data.feeds[0].values[0];
                                $scope.feed = null;
                                $scope.feedPreviewLoading = false;
                                return;
                            }

                            var valueArray = new Array();
                            var maxLength = 0;
                            var fieldLength = data.feeds.length;

                            for (var i = 0; i < data.feeds.length; i++) {
                                if (data.feeds[i].values.length > maxLength)
                                    maxLength = data.feeds[i].values.length;
                            }

                            for (var i = 0; i < maxLength; i++) {
                                var feedItems = new Array();

                                for (var j = 0; j < fieldLength; j++) {
                                    // adding replaceQuote because of the replace code in BannerflowLegacyService.Features.Feeds.Parsing.FeedParser. For more detailed explaination, refer to this https://bannerflow.atlassian.net/browse/SUP-4365?focusedCommentId=185508
                                    if (data.feeds[j].values[i]) {
                                        const replaceQuote = data.feeds[j].values[i].replace(
                                            /&quot;/g,
                                            '"'
                                        );
                                        feedItems.push({
                                            id: data.feeds[j].id,
                                            error: data.feeds[j].error,
                                            name: data.feeds[j].name,
                                            value: replaceQuote
                                        });
                                    } else {
                                        feedItems.push({
                                            id: data.feeds[j].id,
                                            error: data.feeds[j].error,
                                            name: data.feeds[j].name,
                                            value: ""
                                        });
                                    }
                                }

                                valueArray.push(feedItems);
                            }

                            valueArray = valueArray.slice(0, 10);

                            $scope.feed = valueArray;
                            $scope.feedPreviewLoading = false;

                            if (callback) callback();
                        })
                        .error(function () {
                            $scope.isDirty = true;
                            $scope.feedPreviewLoading = false;
                        });
                } else {
                    $scope.feed = null;
                    $scope.feedPreviewLoading = false;
                }
            };

            $scope.selectField = function (field) {
                if (field === $scope.selectedField) $scope.selectedField = null;
                else $scope.selectedField = field;
            };

            $scope.orderOperationMatchStop = function (e, ui) {
                if (!$scope.selectedOperation) return;
                for (var index in $scope.selectedOperation.matches) {
                    $scope.selectedOperation.matches[index].order = index;
                }
            };

            $scope.selectOperation = function (field) {
                if (field === $scope.selectedOperation) {
                    $scope.selectedOperation = null;
                } else {
                    $scope.selectedOperation = field;

                    if ($scope.selectedOperation.matches) {
                        $scope.selectedOperation.matches = _.sortBy(
                            $scope.selectedOperation.matches,
                            function (m) {
                                return m.order;
                            }
                        );
                    }

                    $scope.$watch(
                        "selectedOperation",
                        function (n, o) {
                            if (!n || !n.matches) return;

                            for (var i = n.matches.length - 1; i >= 0; i--) {
                                if ($scope.selectedOperation.type === "5") {
                                    if (n.matches[i].search === "" && n.matches[i].replace === "") {
                                        n.matches.splice(i, 1);
                                    }
                                } else {
                                    if (n.matches[i].search === "") {
                                        n.matches.splice(i, 1);
                                    }
                                }
                            }

                            if ($scope.selectedOperation.type === "5") {
                                if (
                                    n.matches[n.matches.length - 1] &&
                                    (n.matches[n.matches.length - 1].search != "" ||
                                        n.matches[n.matches.length - 1].replace != "")
                                ) {
                                    n.matches.push({ search: "", replace: "", disabled: false });
                                }
                            } else {
                                if (
                                    n.matches[n.matches.length - 1] &&
                                    n.matches[n.matches.length - 1].search != ""
                                ) {
                                    n.matches.push({ search: "", replace: "", disabled: false });
                                }
                            }
                            if (n.matches.length === 0) {
                                n.matches.push({ search: "", replace: "", disabled: false });
                            }
                        },
                        true
                    );
                }
            };

            $scope.selectFieldFromFeed = function (id) {
                if ($scope.navTab === 1) {
                    return;
                }

                var field = _.find($scope.feedData.properties, function (f) {
                    return f.id === id;
                });

                if (field) $scope.selectedField = field;
            };

            $scope.selectTargetURLFeedField = function (field) {
                if (field) $scope.selectedField.targetUrl = "$." + field.Path;
            };

            $scope.openFeedFieldPicker = function (startNode, callback, parentMode, addMode) {
                var dialog = ngDialog.open({
                    className: "feed-field-picker-dialog",
                    template: "/legacy-app/views/Create/Feeds/feed-field-picker.html",
                    data: {
                        startNode: startNode,
                        callback: callback,
                        parentMode: parentMode,
                        addFieldMode: addMode
                    },
                    appendTo: "body"
                });
            };

            $scope.openFeedFieldAdd = function () {
                $scope.openFeedFieldPicker($scope.feedLeafs, $scope.selectFeedField, -1, true);
            };

            $scope.openOperationGroupFieldPicker = function () {
                $scope.openFeedFieldPicker(
                    $scope.feedLeafs,
                    $scope.selectOperationGroupField,
                    1,
                    false
                );
            };

            $scope.openOperationRelativeFieldPicker = function () {
                $scope.openFeedFieldPicker(
                    $scope.getLeafsFromGroupPath($scope.selectedOperation.groupPath),
                    $scope.selectOperationRelativeField,
                    2,
                    false
                );
            };

            $scope.openOperationFieldPicker = function () {
                $scope.openFeedFieldPicker($scope.feedLeafs, $scope.selectOperationField, -1, false);
            };

            $scope.openOperationTargetUrlFieldPicker = function () {
                $scope.openFeedFieldPicker(
                    $scope.feedLeafs,
                    $scope.selectTargetURLFeedField,
                    -1,
                    false
                );
            };

            $scope.selectOperationField = function (field) {
                var arr = field.Path.split(".");
                var relativePath = arr.splice(arr.length - 1, 1)[0];
                var parentPath = arr.join(".");
                var parent = null;

                var func = function (leaf) {
                    if (!leaf || !leaf.Descendants) return;

                    if (leaf.Path === parentPath) parent = leaf;

                    for (var i = 0; i < leaf.Descendants.length; i++) {
                        func(leaf.Descendants[i]);
                    }
                };

                func($scope.feedLeafs);

                if (parent && $scope.selectedOperation) {
                    $scope.selectedOperation.groupPath = parent.Path;
                    $scope.selectedOperation.relativePath = relativePath;
                }
            };

            $scope.getLeafsFromGroupPath = function (groupPath) {
                var relativePath = null;
                var func = function (leaf) {
                    if (!leaf || !leaf.Descendants) return;

                    if (leaf.Path === groupPath) relativePath = leaf;

                    for (var i = 0; i < leaf.Descendants.length; i++) {
                        func(leaf.Descendants[i]);
                    }
                };

                func($scope.feedLeafs);

                return relativePath;
            };

            $scope.selectOperationRelativeField = function (field) {
                if (field) {
                    $scope.selectedOperation.relativePath = $scope.getEndFieldNameRelative(field.Path);
                }
            };

            $scope.selectOperationGroupField = function (field) {
                if (field) {
                    $scope.selectedOperation.groupPath = field.Path;

                    $scope.selectedOperation.relativePath = $scope.getEndFieldNameRelative(
                        field.Descendants[0].Path
                    );
                }
            };

            $scope.selectFeedField = function (field) {
                if (!field) {
                    return;
                }
                if (Object.prototype.toString.call(field) === "[object Array]") {
                    var tempArr = new Array();
                    for (var i = 0; i < field.length; i++) {
                        var name = field[i].Name;

                        var item = {
                            id: makeGUID(),
                            name: $scope.generateUniqeName(name),
                            path: "$." + field[i].Path
                        };

                        $scope.feedData.properties.push(item);
                        tempArr.push(item);
                    }
                    $timeout(function () {
                        for (var i = 0; i < tempArr.length; i++) {
                            $("#fi" + tempArr[i].id).css("background", "#90DBB5");
                            $("#fi" + tempArr[i].id)
                                .delay(100)
                                .animate({ backgroundColor: "white" }, 350);
                        }
                    }, 150);
                    $scope.selectedField = null;
                } else {
                    $scope.selectedField.path = "$." + field.Path;

                    $("#f" + $scope.selectedField.id).css("background", "#90DBB5");
                    $("#f" + $scope.selectedField.id)
                        .delay(100)
                        .animate({ backgroundColor: "white" }, 350);
                }
            };

            $scope.deleteFeedField = function (field) {
                $scope.feedData.properties = _.reject($scope.feedData.properties, function (item) {
                    return item.id === field.id;
                });
                $scope.selectedField = null;
            };

            $scope.duplicateFeedField = function (field) {
                var copy = angular.copy(field);
                copy.id = makeGUID();
                copy.name = $scope.generateUniqeName(field.name);

                var index = $scope.feedData.properties.indexOf(field);

                if (index != -1) {
                    $scope.feedData.properties.splice(index + 1, 0, copy);
                } else {
                    $scope.feedData.properties.push(copy);
                }
            };

            $scope.disableFeedOperation = function (op) {
                op.disabled = !op.disabled;
            };

            $scope.deleteFeedOperation = function (op) {
                $scope.feedData.operations = _.reject($scope.feedData.operations, function (o) {
                    return o.id === op.id;
                });
                $scope.selectedOperation = null;
            };

            $scope.duplicateFeedOperation = function (op) {
                var copy = angular.copy(op);
                copy.id = makeGUID();
                copy.name = $scope.generateUniqeName(copy.name);

                var index = $scope.feedData.operations.indexOf(op);

                if (index != -1) {
                    $scope.feedData.operations.splice(index + 1, 0, copy);
                } else {
                    $scope.feedData.operations.push(copy);
                }
            };

            $scope.orderOperationStop = function (e, ui) {
                for (var index in $scope.feedData.operations) {
                    $scope.feedData.operations[index].position = index;
                }
            };

            $scope.orderPropertiesStop = function (e, ui) {
                for (var index in $scope.feedData.properties) {
                    $scope.feedData.properties[index].position = index;
                }
            };

            $scope.getEndFieldName = function (field) {
                if (!field) return "";

                return $scope.getEndFieldFromString(field.groupPath);
            };

            $scope.getEndFieldNameRelative = function (path) {
                if (!path || !$scope.selectedOperation) return "";

                const prefix = $scope.selectedOperation.groupPath;
                const prefixWithDot = prefix + ".";

                // When the JPath is messed up due to having . in the field name like "games.game_id",
                // the whole collection of leafs and JPaths are a bit messy. Therefore we need to handle both sanitizations.
                if (path.startsWith(prefixWithDot)) {
                    return path.slice(prefixWithDot.length);
                }
                if (path.startsWith(prefix)) {
                    return path.slice(prefix.length);
                }
                return path;
            };

            $scope.getEndFieldFromString = function (str) {
                var arr = str.split(".");

                if (arr.length == 0) return "";

                return arr[arr.length - 1].replace("[*]", "");
            };

            $scope.getAllFieldParents = function () {
                var parents = new Array();

                var func = function (leaf) {
                    if (!leaf || !leaf.Descendants) return;

                    if (leaf.Descendants.length > 1) parents.push(leaf);

                    for (var i = 0; i < leaf.Descendants.length; i++) {
                        func(leaf.Descendants[i]);
                    }
                };

                func($scope.feedLeafs);

                return parents;
            };

            $scope.openAddOperationPicker = function () {
                var dialog = ngDialog.open({
                    className: "operation-picker",
                    template: "/legacy-app/views/Create/Feeds/operation-picker.html",
                    data: {
                        operations: $scope.operations,
                        callback: function (operation) {
                            $scope.addOperation(operation);
                            dialog.close();
                        }
                    },
                    appendTo: "body"
                });
            };

            $scope.addOperation = function (template) {
                var copy = angular.copy(template);
                copy.id = makeGUID();

                $scope.feedData.operations.push(copy);

                $scope.selectOperation(
                    $scope.feedData.operations[$scope.feedData.operations.length - 1]
                );

                $scope.showAddOperationPicker = false;
                $rootScope.modalOpen = false;

                $scope.orderOperationStop();
            };

            $scope.saveFeed = function () {
                $scope.isSaving = true;

                var updateRequest = angular.copy($scope.feedData);
                updateRequest = $scope.cleanUpFeedRequest(updateRequest, true);

                const feed = new Feed(updateRequest);
                feed.$update(function (data) {
                    $scope.selectedField = null;
                    $scope.selectedOperation = null;
                    $scope.loadFeed(data);

                    Notification.Show("Feed saved");
                });
            };

            $scope.validateName = function () {
                var data = angular.copy($scope.feedData);
                if (data.name == "") $scope.disableSaveFeed = true;
                else $scope.disableSaveFeed = false;
            };

            $scope.unlockFeed = function () {
                var dialog = ngDialog.open({
                    className: "confirm-lock-dialog",
                    template: "/legacy-app/views/Dialogs/confirmLock.html",
                    controller: "ConfirmLockDialogController",
                    data: {
                        items: [$scope.feedData],
                        type: $rootScope.OBJECT_TYPE_FEED,
                        lock: false,
                        resource: Feed
                    },
                    appendTo: "body"
                });
                dialog.closePromise.then(function (data) {
                    if (data.value != "cancel") {
                        location.reload();
                    }
                });
            };
        }
    );
